import { render, staticRenderFns } from "./TopNavMobile.vue?vue&type=template&id=445567ec&"
import script from "./TopNavMobile.vue?vue&type=script&lang=ts&"
export * from "./TopNavMobile.vue?vue&type=script&lang=ts&"
import style0 from "./TopNavMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Search: require('/home/runner/work/did-homepage/did-homepage/src/components/Search.vue').default,WalletConnectButton: require('/home/runner/work/did-homepage/did-homepage/src/components/WalletConnectButton.vue').default})
